<div class="painel mat-elevation-z8">
<h2>Gerenciar Vagas<br/><small>Varal de Oportunidades</small></h2>

    <div class="campos">
        <mat-form-field style="width: 100%; margin:15px">
            <mat-label>Filtro</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Vendedor" #input>
        </mat-form-field>
    </div>
    <div class="campos" style="text-align: right;">
        <button mat-raised-button color="accent" (click)="Salvar()" style="margin:15px">Salvar Modificações</button>
    </div>
    <div class="table">
        <table 
        mat-table
        #table
        [dataSource]="dataSource"
        class="mat-elevation-z8"
        cdkDropList
        (cdkDropListDropped)="drop($event)"
        cdkDropListData="dataSource"
        [cdkDropListDisabled]="dragDisabled"
        >
            <ng-container matColumnDef="order">
                <th mat-header-cell *matHeaderCellDef>  </th>
                <td mat-cell *matCellDef="let element">
                    <mat-icon class="dragCursor" (mousedown)="dragDisabled = false;" style="margin: 5px;">reorder</mat-icon>
                </td>
            </ng-container>
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef> Nro. </th>
                <td mat-cell *matCellDef="let element">
                    {{element.order}}
                </td>
            </ng-container>
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef> Processo Seletivo </th>
                <td mat-cell *matCellDef="let row"> {{row.name}} </td>
            </ng-container>
            <ng-container matColumnDef="created_at">
                <th mat-header-cell *matHeaderCellDef> Criado em </th>
                <td mat-cell *matCellDef="let row"> {{row.created_at | date:'dd/MM/yyyy hh:mm'}} </td>
            </ng-container>
            <ng-container matColumnDef="end_at">
                <th mat-header-cell *matHeaderCellDef> Finalizado em </th>
                <td mat-cell *matCellDef="let row"> {{row.end_at | date:'dd/MM/yyyy hh:mm'}} </td>
            </ng-container>
            <ng-container matColumnDef="show">
                <th mat-header-cell *matHeaderCellDef> Mostrar </th>
                <td mat-cell *matCellDef="let row"> 
                    <mat-slide-toggle [checked]="row.show" (change)="row.show = $event.checked"></mat-slide-toggle>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr 
                mat-row *matRowDef="let row; columns: displayedColumns;" 
                cdkDrag
                [cdkDragData]="row"
            ></tr>
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">Não foram encontrados resultados para a palavra chave "{{input.value}}"</td>
            </tr>
        </table>
        <!-- <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Selecione a página do processo seletivo"></mat-paginator> -->
    </div>
</div>
  
  